import React, {memo, useState, useMemo, useContext} from "../../__snowpack__/pkg/react.js";
import {arrayMove, SortableContainer, SortableElement} from "../../__snowpack__/pkg/react-sortable-hoc.js";
import styled from "../../__snowpack__/pkg/styled-components.js";
import "./pictureGrid.css";
import {checkImageWH} from "./uploaderUtils.js";
import {imagePreview} from "../lib/pictureUtil.js";
import UploadList from "../../__snowpack__/pkg/antd/es/upload/UploadList.js";
import {Modal, message, Upload, Tooltip} from "../../__snowpack__/pkg/antd.js";
import {IconPlus} from "../../__snowpack__/pkg/@genieui-react/icon.js";
import {isEmpty} from "../../__snowpack__/pkg/lodash.js";
import LocaleContext from "../../__snowpack__/pkg/antd/es/locale-provider/context.js";
import {SessionHelper} from "../../__snowpack__/pkg/@genie/lib-iam-utils.js";
const itemStyle = {
  width: 104,
  margin: 4,
  cursor: "grab"
};
const i18n = {
  "zh-cn": {
    invalidSizeMsg: "\u56FE\u7247\u5FC5\u987B\u662FJPG\u3001PNG\u683C\u5F0F\uFF0C\u6700\u59274MB",
    invalidWhMsg: "\u5206\u8FA8\u7387\uFF1A300*300px\uFF5E1024*1024px"
  },
  en: {
    invalidSizeMsg: "Image must be JPG, PNG format, max. 4MB",
    invalidWhMsg: "Resolution: 300*300px\uFF5E1024*1024px"
  },
  id: {
    invalidSizeMsg: "Gambar harus dalam format JPG, PNG, maks. 4MB",
    invalidWhMsg: "Resolusi: 300*300px\uFF5E1024*1024px"
  },
  vi: {
    invalidSizeMsg: "H\xECnh \u1EA3nh b\u1EAFt bu\u1ED9c l\xE0 \u0111\u1ECBnh d\u1EA1ng JPG, PNG, t\u1ED1i \u0111a 4MB",
    invalidWhMsg: "\u0110\u1ED9 ph\xE2n gi\u1EA3i: 300 * 300px \uFF5E 1024 * 1024px"
  },
  th: {
    invalidSizeMsg: "\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A JOG, PNG, \u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14 4MB",
    invalidWhMsg: "\u0E04\u0E27\u0E32\u0E21\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14: 300*300px\uFF5E1024*1024px	"
  }
};
const listStyle = {
  display: "flex",
  flexWrap: "wrap",
  maxWidth: "100%"
};
const UploaderDrag = memo(({onChange: onFileChange, ...props}) => {
  const {locale} = useContext(LocaleContext);
  const limitNumLen = props.limitNum || 1;
  const curRequiredLabel = useMemo(() => {
    if (!isEmpty(props.requiredLabel) && typeof props.requiredLabel === "string") {
      return props.requiredLabel;
    }
  }, [props.requiredLabel, props.fileList]);
  const SortableItem = SortableElement((params) => /* @__PURE__ */ React.createElement("div", {
    style: itemStyle
  }, /* @__PURE__ */ React.createElement(UploadList, {
    locale: {},
    showDownloadIcon: false,
    listType: params.props.listType,
    onPreview: params.onPreview,
    onRemove: params.onRemove,
    items: [params.item],
    itemRender: (node, file) => {
      return /* @__PURE__ */ React.createElement("div", {
        className: "uploader-item"
      }, node, /* @__PURE__ */ React.createElement(Tooltip, {
        title: file.name,
        placement: "topLeft"
      }, /* @__PURE__ */ React.createElement("div", {
        className: "upload-item-title"
      }, params.props.itemTitleRender ? params.props.itemTitleRender(params.itemIndex) : file.name)));
    }
  })));
  const SortableList = SortableContainer((params) => {
    return /* @__PURE__ */ React.createElement("div", {
      style: listStyle
    }, params.items.map((item, index) => /* @__PURE__ */ React.createElement(SortableItem, {
      key: `${item.uid}`,
      item,
      props: params.props,
      index,
      itemIndex: index,
      onPreview: params.onPreview,
      onRemove: params.onRemove
    })), (!limitNumLen || params.items.length < limitNumLen) && /* @__PURE__ */ React.createElement("div", {
      style: itemStyle
    }, /* @__PURE__ */ React.createElement(Upload, {
      ...params.props,
      action: "/saas/product/v1/images",
      showUploadList: false,
      onChange: (files) => {
        let cvFiles = {...files};
        cvFiles.file = {
          ...cvFiles.file,
          response: cvFiles.file.response?.data || cvFiles.file.response
        };
        cvFiles.fileList = cvFiles.fileList?.map((data) => {
          return {
            ...data,
            response: data?.response?.data || data?.response
          };
        });
        params.onChange(cvFiles);
      },
      listType: "picture-card",
      name: "image",
      maxCount: limitNumLen || 1,
      multiple: true,
      accept: "image/jpeg,image/png,image/jpg",
      beforeUpload: async (file) => {
        if (props.limitWH) {
          try {
            await checkImageWH(file, props.limitWH[0], props.limitWH[1]);
          } catch (error) {
            message.error(props.invalidWhMsg || i18n[locale].invalidWhMsg);
            return Promise.reject("Invalid WH");
          }
        }
        if (props.limitSizeM) {
          if (file.size / 1024 / 1024 > props.limitSizeM) {
            message.error(props.invalidSizeMsg || i18n[locale].invalidSizeMsg);
            return Promise.reject("Invalid Size");
          }
        }
        return Promise.resolve(file);
      },
      headers: {Authorization: SessionHelper.getSessionToken() ?? ""}
    }, /* @__PURE__ */ React.createElement("div", {
      className: "uploader-button"
    }, /* @__PURE__ */ React.createElement(IconPlus, {
      primaryColor: "#7F8FA4",
      style: {display: "block", width: 21, height: 21}
    }), curRequiredLabel && /* @__PURE__ */ React.createElement(Tooltip, {
      title: curRequiredLabel,
      placement: "topLeft"
    }, /* @__PURE__ */ React.createElement("div", {
      id: props.id,
      className: "upload-button-title"
    }, curRequiredLabel))))));
  });
  const [previewImage, setPreviewImage] = useState("");
  const fileList = props.fileList || [];
  const onSortEnd = ({oldIndex, newIndex}) => {
    onFileChange({fileList: arrayMove(fileList, oldIndex, newIndex)});
  };
  const onChange = ({fileList: newFileList}) => {
    onFileChange({fileList: newFileList});
  };
  const onRemove = (file) => {
    const newFileList = fileList.filter((item) => item.uid !== file.uid);
    onFileChange({fileList: newFileList});
  };
  const onPreview = async (file) => {
    await imagePreview(file, ({image}) => {
      setPreviewImage(image);
    });
  };
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(SortableList, {
    distance: 1,
    items: fileList,
    onSortEnd,
    axis: "xy",
    helperClass: "SortableHelper",
    props,
    onChange,
    onRemove,
    onPreview
  }), /* @__PURE__ */ React.createElement(Modal, {
    visible: !!previewImage,
    footer: null,
    onCancel: () => setPreviewImage(""),
    bodyStyle: {padding: 0}
  }, /* @__PURE__ */ React.createElement("img", {
    style: {width: "100%"},
    alt: "",
    src: previewImage
  })));
});
export {UploaderDrag};
const Wrapper = styled.div`
  &.uploader {
  }
  /* 拖动的时候的样式 */
  .SortableHelper {
    box-shadow: rgba(0, 0, 0, 0.075) 0 1px 6px, rgba(0, 0, 0, 0.075) 0 1px 4px;
    background-color: lightgreen;
    z-index: 8888;
  }
  .uploader-button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .upload-button-title {
      position: absolute;
      width: 100px;
      left: 0;
      bottom: -22px;
      font-size: 12px;
      font-family: SFProText-Regular, SFProText;
      font-weight: 400;
      color: #7f8fa4;
      line-height: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .uploader-item {
    width: 100px;
    height: auto;
    .upload-item-title {
      display: block;
      text-align: center;
      margin-top: 8px;
      font-size: 12px;
      font-family: SFProText-Regular, SFProText;
      font-weight: 400;
      color: #7f8fa4;
      line-height: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .ant-upload-list-picture-card-container {
    width: 100px;
    height: auto;
    margin-right: 24px;
  }
  .ant-upload-list-picture-card .ant-upload-list-item {
    width: 100px;
    height: 100px;
  }
  .ant-upload.ant-upload-select-picture-card {
    position: relative;
    width: 100px;
    height: 100px;
    background: #fafdff;
    border-radius: 4px;
    border: 1px dashed #7f8fa4;
    margin-bottom: 30px;
  }
`;
